export const FETCH_ACTUAL_BOOKINGS =  "fetch_actual_bookings";
export const FETCH_ACTUAL_BOOKINGS_SUCCESS =  "fetch_actual_bookings_success";
export const FETCH_TEMPORY_BOOKINGS =  "fetch_tempory_bookings";
export const FETCH_TEMPORY_BOOKINGS_SUCCESS =  "fetch_tempory_bookings_success";
export const CREATE_CONSULTATION = "create_consultation";
export const CREATE_CONSULTATION_SUCCESS = "create_consultation_success";